<template>
    <div class="row mt-5">
        <div class="col-12">
            <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
                <thead>
                    <tr class="text-light text-center" style="background-color: #2a3042 !important">
                        <th scope="col">{{ $t('hr_employees.penalty_id') }}</th>
                        <th scope="col">{{ $t('hr_employees.penalty_amount') }}</th>
                        <th scope="col">{{ $t('hr_employees.month') }}</th>
                        <th scope="col">{{ $t('hr_employees.year') }}</th>
                        <th scope="col">{{ $t('hr_employees.description') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-center" v-for="(item, index) in penalty" :key="index">
                        <td>{{ item.emp_id }}</td>
                        <td>{{ Number(item.amount).toLocaleString() }}</td>
                        <td>{{ item.month }}</td>
                        <td>{{ item.year }}</td>
                        <td v-html="item.description"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-center mt-4">
            <BPagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            penalty: {},
            rows: 0,
            perPage: 10,
            currentPage: 1
        };
    },
    methods:{
        GetPenalty() {
            this.http.post('penalty/emplyee-penalties', {emp_id: this.$route.params.id, limit: this.perPage, page: this.currentPage}).then((res) => {
                this.penalty = res.data;
                this.rows = res.total;
            })
        }
    },
    mounted() {
        this.GetPenalty();
    }
}
</script>
<style lang="">
    
</style>